import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PopupTextInputModal } from '../../../../../components/common/modal/popup/PopupTextInputModal';
import { SlideConfirmModal } from '../../../../../components/common/modal/slide/SlideConfirmModal';
import { SurveyForm } from '../../../../../components/common/survey/form/SurveyForm';
import { SurveyCheckboxInput } from '../../../../../components/common/survey/inputs/SurveyCheckboxInput';
import { SurveyInputContainer } from '../../../../../components/common/survey/inputs/SurveyInputContainer';
import { SurveyInputHeader } from '../../../../../components/common/survey/inputs/SurveyInputHeader';
import { joinProcessConstants } from '../../../../../constants/joinProcess';
import { useAppDispatch } from '../../../../../hooks/store/useStore';
import { userJoinSlice } from '../../../../../store/userJoinSlice';
import { JoinProcessPageWrapper } from '../JoinProcessPageWrapper';

export const JoinProcessReasonPage = () => {
  const navigate = useNavigate();

  const [selectedReason, setSelectedReason] = useState<string[]>([]);
  const [isSlideModalOpen, setIsSlideModalOpen] = useState<boolean>(false);
  const [isPopupModalOpen, setIsPopupModalOpen] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  const userJoinActions = userJoinSlice.actions;

  const confirmHandler = () => {
    dispatch(userJoinActions.changeJoinReasons(selectedReason.join(',')));
    navigate('/join-process/tractor-own-check', { replace: true });
  };

  const confirmSlideModal = () => {
    setIsSlideModalOpen(false);
    setIsPopupModalOpen(true);
  };

  const closeSlideModal = () => {
    setIsSlideModalOpen(false);
  };

  const confirmPopupModal = (detailReason: string) => {
    dispatch(userJoinActions.changeJoinReasonEtc(detailReason));
    setIsPopupModalOpen(false);
  };

  return (
    <>
      <JoinProcessPageWrapper
        headerTitle={'가입 이유를 알고 싶어요'}
        canConfirm={selectedReason.length >= 1}
        confirmHandler={confirmHandler}
      >
        <SurveyForm>
          <SurveyInputHeader inputTitle={'가입 목적 선택'} canDuplicate />

          <SurveyInputContainer gridColumns={2}>
            {joinProcessConstants.reason.values.map((value, index) => (
              <SurveyCheckboxInput
                key={value}
                title={value}
                label={
                  joinProcessConstants.reason.labels && joinProcessConstants.reason.labels.length > 0
                    ? joinProcessConstants.reason.labels[index]
                    : undefined
                }
                onClick={() => {
                  if (selectedReason.includes(value)) {
                    setSelectedReason((prev) => prev.filter((selectedValue) => selectedValue !== value));
                  } else {
                    setSelectedReason((prev) => [...prev, value]);

                    if (value === '기타') {
                      setIsSlideModalOpen(true);
                    }
                  }
                }}
                isChecked={selectedReason.includes(value)}
              />
            ))}
          </SurveyInputContainer>
        </SurveyForm>
      </JoinProcessPageWrapper>

      <SlideConfirmModal
        isShow={isSlideModalOpen}
        height={189}
        description={'혹시 이유를 간략하게 적어 주실 수 있나요?'}
        confirmButton={{ handleClick: confirmSlideModal, text: '네, 그렇게 할게요.' }}
        closeButton={{ handleClick: closeSlideModal, text: '닫기' }}
      />

      <PopupTextInputModal
        isShow={isPopupModalOpen}
        title={'간략하게 적어주세요 🙂'}
        placeholder={'예) 지인의 권유'}
        confirmText={'완료'}
        confirmHandler={(value: string) => {
          confirmPopupModal(value);
        }}
      />
    </>
  );
};
